import DropdownLinkItem from "core/dropdown/DropdownLinkItem";
import Icon from "core/icon/Icon";
import { FormattedMessage } from "react-intl";
import { displayFileBrowser } from "utils/helper";

export const createEmptyPictureOptions = (displayFileBrowserFunc, inputId) => [
  {
    value: "add_picture",
    label: { id: "add_picture", label: "Ajouter une photo" },
    icon: "download",
    color: "light-slate-gray",
    onClick: () => displayFileBrowserFunc({ inputElem: inputId }),
  },
];

export const createPictureOptions = (
  setInputClicked,
  onClearPicture,
  inputFileRef,
  setCreatedFile,
  onChange,
  inputId
) => [
  {
    value: "change_picture",
    label: { id: "change_picture", label: "Changer photo" },
    icon: "switch",
    color: "light-slate-gray",
    onClick: () => {
      setInputClicked(false);
      displayFileBrowser({ inputElem: inputId });
    },
  },
  {
    value: "delete_picture",
    label: { id: "delete_picture", label: "Supprimer photo" },
    icon: "red-trash",
    color: "red",
    onClick: () => {
      setInputClicked(false);
      // Support both: callback function or legacy setInput
      if (typeof onClearPicture === "function") {
        onClearPicture();
      }
    },
  },
];

export const renderEmptyPictureOptions = (
  setInputClicked,
  displayFileBrowserFunc,
  inputId
) => {
  const emptyPictureOptions = createEmptyPictureOptions(displayFileBrowserFunc, inputId);
  return emptyPictureOptions?.map((data) => (
    <DropdownLinkItem
      id={data?.label?.id}
      key={data?.label?.id}
      onClick={(e) => {
        setInputClicked(false);
        data?.onClick();
        e?.stopPropagation();
      }}
    >
      <Icon
        icon={data.icon}
        color={data.color}
        width={10}
        height={10}
        marginRight={10}
      />
      <span style={{ color: data.color }}>
        <FormattedMessage {...data.label} />
      </span>
    </DropdownLinkItem>
  ));
};

export const renderPictureOptions = (
  setInputClicked,
  setInput,
  inputFileRef,
  setCreatedFile,
  onChange,
  inputId
) => {
  const pictureOptions = createPictureOptions(
    setInputClicked,
    setInput,
    inputFileRef,
    setCreatedFile,
    onChange,
    inputId
  );
  return pictureOptions?.map((data) => (
    <DropdownLinkItem
      id={data?.label?.id}
      key={data?.label?.id}
      onClick={(e) => {
        data?.onClick();
        e?.stopPropagation();
      }}
    >
      <Icon
        icon={data.icon}
        color={data.color}
        width={10}
        height={10}
        marginRight={10}
      />
      <span style={{ color: data.color }}>
        <FormattedMessage {...data.label} />
      </span>
    </DropdownLinkItem>
  ));
};
